module.exports = __webpack_public_path__ + "static/media/fi.2b323d08.svg";